import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px ${({ theme: { token } }) => token.padding}px;
  gap: ${({ theme: { token } }) => token.margin}px;

  .ant-card {
    .details-widget-slider {
      margin-bottom: ${({ theme: { token } }) => token.margin}px;

      .slider-container {
        .value {
          margin-bottom: 0;

          .value-content {
            font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
          }

          .units-sign {
            bottom: 4px;
          }
        }

        .slider {
          &:before {
            margin-left: -16.2601626%;
            width: 16.2601626%;
          }

          &:after {
            margin-right: -16.2601626%;
            width: 16.2601626%;
          }
        }

        .triangle {
          height: 8px;
          width: 12px;
          margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
        }
      }
    }
  }

  .alert-tab-label {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    font-size: ${({ theme: { token } }) => token.fontSize}px;

    &.archived {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
    }
  }

  .sliders-horizontal-icon {
    line-height: ${({ theme: { token } }) => token.lineHeight}px;
  }
`;
